module.exports = __webpack_public_path__ + "img/ZRX.20d2751f.svg";